export class PqrLenguagePersonEntity{
    
    id:number;
    userId:number;
    languageId: number;
    constructor (){}
}